import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Avatar,
  LetterAvatar,
  Text,
  Dropdown,
  IconButton,
  Icon,
  DropdownMenuItem,
  TimeAgo,
  H4
} from '../../../../../components';

const SourceItemWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  width: 100%;
`;

const StyledDropdown = styled(Dropdown)`
  margin-left: auto;
`;

const SourceItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

const StyledText = styled(Text)`
  display: flex;
  align-items: flex-end;
  column-gap: 2px;
`;

const SourceItem = ({ name, picture = null, lastSync = null, onDelete }) => (
  <SourceItemWrapper>
    {picture ? <Avatar width={40} src={picture} /> : <LetterAvatar size={40} name={name} />}
    <SourceItemDetails>
      <H4>{name}</H4>
      <StyledText $color='var(--content-muted)'>
        <Icon name='sync' displaySize={20} color='var(--content-muted)' />
        Last sync: {lastSync ? <TimeAgo timestamp={lastSync} /> : 'never'}
      </StyledText>
    </SourceItemDetails>
    <StyledDropdown
      menuPlacement='bottom-end'
      toggleComponent={<IconButton small iconName='ellipsis' naked />}
    >
      {() => (
        <>
          <DropdownMenuItem leftIcon={<Icon name='cloud-disconnect' displaySize={20} />} disabled>
            Pause syncing
          </DropdownMenuItem>
          <DropdownMenuItem
            leftIcon={<Icon name='cloud-sync' displaySize={20} />}
            onClick={onDelete}
          >
            Disconnect
          </DropdownMenuItem>
        </>
      )}
    </StyledDropdown>
  </SourceItemWrapper>
);

SourceItem.propTypes = {
  name: PropTypes.string.isRequired,
  picture: PropTypes.string,
  lastSync: PropTypes.string,
  onDelete: PropTypes.func.isRequired
};

export { SourceItem };
